import { Card, Grid } from '@mui/material';
import { ComponentProps } from 'react';
import { PercentageBarChart } from '../../../../ui/components/pure/charts/percentage-bar/percentage-bar.component';
import { PercentageBarChartPlaceholder } from '../../../../ui/components/pure/charts/percentage-bar/percentage-bar.placeholder';
import {
  lockerSizeToLockerIconColorMap,
  lockerSizeToLockerIconMap,
  sortByLockerSize
} from '../../../lockers/logic/locker-ui.constants';
import { useDashboardStatsContext } from '../../context/use-dashboard-stats.context';
import { LockerUtilisationHeader } from './locker-utilisation-header/locker-utilisation-header';
import { useLockerUtilisationStyles } from './locker-utlisation.styles';

export function LockerUtilisation() {
  const classes = useLockerUtilisationStyles();
  const { lockerUtilisation } = useDashboardStatsContext();

  const isLoading = lockerUtilisation.isLoading;
  const lockerUtilisationData = lockerUtilisation.data;

  if (typeof lockerUtilisationData === 'undefined') {
    return null;
  }

  const allLockerSizes = lockerUtilisationData.all;
  const sortedAllLockerSizes = sortByLockerSize(allLockerSizes, (count) => count.lockerSize);
  const rows: ComponentProps<typeof PercentageBarChart>['rows'] = sortedAllLockerSizes.map((count) => ({
    count: {
      value: lockerUtilisationData.inUse.find((c) => c.lockerSize === count.lockerSize)?.value || 0,
      total: count.value,
      label: 'in use'
    },
    icon: {
      Icon: lockerSizeToLockerIconMap(false, count.lockerSize),
      alt: count.lockerSize,
      label: count.lockerSize
    },
    color: lockerSizeToLockerIconColorMap(count.lockerSize),
    percentage: lockerUtilisationData.occupancy.find((c) => c.lockerSize === count.lockerSize)?.value || 0
  }));

  return (
    <Card className={classes.card}>
      <Grid container>
        <LockerUtilisationHeader />
      </Grid>
      <Grid container>
        {isLoading ? (
          <PercentageBarChartPlaceholder rowCount={3} />
        ) : rows.length > 0 ? (
          <PercentageBarChart rows={rows} />
        ) : (
          <div className={classes.noDataMessage}>
            <p>No data</p>
          </div>
        )}
      </Grid>
    </Card>
  );
}
